module.exports = __webpack_public_path__ + "img/detail_icon_video82.c03ffb0e.png";